import { useEffect, useState } from "react";
import type { Business } from "@/types/directory";
import { getRelatedBusinesses } from "@/services/directoryService";
import BusinessCard from "@/components/base/BusinessCard";
import SectionHeading from "@/components/base/SectionHeading";

interface SimilarBusinessesProps {
  business: Business;
}

export default function SimilarBusinesses({ business }: SimilarBusinessesProps) {
  const [related, setRelated] = useState<Business[]>([]);

  useEffect(() => {
    let active = true;
    getRelatedBusinesses(business, 3)
      .then((list) => {
        if (active) setRelated(list);
      })
      .catch(() => {
        if (active) setRelated([]);
      });
    return () => {
      active = false;
    };
  }, [business]);

  if (related.length === 0) {
    return null;
  }

  return (
    <section className="mt-12 w-full bg-[#F5F7FA] py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1400px] px-6">
        <SectionHeading
          eyebrow="You may also like"
          title={`Similar businesses to ${business.name}`}
          description="More verified options in the same category or district on the Canara coast."
          action={{ label: "Browse more", to: `/category/${business.categorySlug}` }}
        />
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((item) => (
            <BusinessCard key={item.id} business={item} />
          ))}
        </div>
      </div>
    </section>
  );
}